<template>
  <div>
    <v-container :class="ui.bkgdColor">
      <v-layout row>
        <v-spacer/>
        <v-btn :color="btnSpecChange.color" @click="changeLocalDataThenDetail()"
        flat v-if="btnSpinChangeDetail === false && enableDetailChange"
          :disabled="
          this.getDataSavePendingIndication === false ||
          !this.licenceOK">
          <v-icon left> {{btnSpecChange.icon}} </v-icon>
          {{btnSpecChange.title}}
        </v-btn>
        <BtnSpin :btnSpec="btnInfo1" v-if="btnSpinChangeDetail === true"/>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import licenceFunctions from "@/admin/functions/mixins/licenceFunctions.js";
import adminFunctions from "@/admin/functions/mixins/adminFunctions.js";
import BtnSpin from "@/frame/animation/components/BtnSpin";
import uisettings from "@/frame/theme/mixins/uisettings.js";
import changeDetail from "@/support/detail/mixins/changeDetail.js";
// import GetDetailPage from "@/support/detail/components/GetDetailPage";

export default {
  data() {
    return {
      valid: true,
      ctr: 0,
      btnSpinChangeDetail: false,
      btnInfo1: {
        color: "red",
        icon: "person",
        name: "add user"
      }
    };
  },
  props: {
    data: {
      type: Object
    }
  },
  mixins: [uisettings, changeDetail, licenceFunctions, adminFunctions],
  components: {
    BtnSpin
    // GetDetailPage
  },
  beforeMount() {
    // TO ENSURE that UPLOAD BTN is LOCKED
    // IF STATUS === CLOSED
    this.changeTransCloseCtr();
  },
  computed: {
    ...mapGetters([
      "getCurrentPage",
      "getDetailBasic",
      "getDataSavePendingIndication",
      "getTransitions"
    ]),
    ui() {
      return this.uiTheme1;
    },
    enableDetailChange() {
      let logic = null;
      let status = null;
      // APPROVED TRANS is in DETAIL
      let trans = this.getDetail.trans;
      if (trans !== null && trans !== undefined) {
        let flow = trans.flow;
        status = flow[flow.length - 1].title;
      }
      if (status === "Closed" && this.ctr > 0) {
        logic = false;
      } else if (status === "Cancelled" && this.ctr > 0) {
        logic = false;
      } else {
        logic = true;
      }
      return logic;
    },
    btnSpecChange() {
      let obj = {
        title: "upload",
        icon: "cloud",
        color: this.ui.btnColor
      };
      if (this.getTransitions !== null && this.getTransitions !== undefined) {
        let flow = this.getTransitions.flow;
        let status = flow[flow.length - 1].title;
        if (status === "Completed") {
          obj.title = "close";
          obj.icon = "cloud_done";
          obj.color = this.ui.colorWarning;
        }
        if (status === "Closed") {
          obj.title = "close";
          obj.icon = "cloud_done";
          obj.color = this.ui.colorWarning;
        }
        if (status === "Cancelled") {
          obj.title = "cancel";
          obj.icon = "cloud_done";
          obj.color = this.ui.colorWarning;
        }
      }
      return obj;
    }
  },
  methods: {
    // TO ENSURE that UPLOAD BTN is LOCKED
    // IF STATUS === CLOSED
    changeTransCloseCtr() {
      let trans = this.getDetail.trans;
      if (trans !== null && trans !== undefined) {
        let flow = trans.flow;
        let status = flow[flow.length - 1].title;
        if (status === "Closed" || status === "Cancelled") {
          this.ctr = 1;
        }
      }
    },
    changeLocalDataThenDetail() {
      this.changeTransCloseCtr();
      this.changeDetail();
    },
    closeDetail() {
      if (this.getCurrentPage == "/maintstrategyedit") {
        this.$router.push("/facilitydashmaint");
      }
    }
  }
};
</script>
